import { render, staticRenderFns } from "./Station_5.vue?vue&type=template&id=4068c2c6&scoped=true&"
import script from "./Station_5.vue?vue&type=script&lang=js&"
export * from "./Station_5.vue?vue&type=script&lang=js&"
import style0 from "./Station_5.vue?vue&type=style&index=0&id=4068c2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4068c2c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VSimpleTable})
